
/**
 * These are the Bootstrap responsive breakpoints, stored here so we don't need
 * to have magic numbers scattered across the codebase.
 * 
 * Source:
 * https://getbootstrap.com/docs/4.5/layout/overview/#responsive-breakpoints
 */

export const LayoutBreakpoints = {
  xs: { min: 0, max: 575.99 },
  sm: { min: 576, max: 767.99 },
  md: { min: 768, max: 991.99 },
  lg: { min: 992, max: 1199.99 },
  xl: { min: 1200, max: Infinity }
};
